import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import { store } from "./store/store";
import { ToastContainer } from 'react-toastify';
import './index.css';
import App from './App';
import '../src/assets/css/style.css'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
    <ToastContainer />
     <App />
    </React.StrictMode>
  </Provider>
);
